module.exports = __webpack_public_path__ + "img/logo_wide_white.28481405.png";